// @flow

export const getSearchParameter = (search: string, paramName: string) => {
  const searchString = search.substring(1),
    params = searchString.split('&')
  let i, val

  for (i = 0; i < params.length; i++) {
    val = params[i].split('=')
    if (val[0] === paramName) {
      return decodeURIComponent(val[1])
    }
  }
  return null
}



// WEBPACK FOOTER //
// ./src/homepage/helpers.js